export const GET_SITES_REQUEST = "GET_SITES_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_SITE = 'INSERT_SITE'
export const DELETE_SITE = 'DELETE_SITE'